import Contact from '__core/shared/model/contact/Contact';
import ContactCompanyIndividual from '__core/shared/model/contact/ContactCompanyIndividual';
import ContactPersonEmployment from '__core/shared/model/contact/ContactPersonEmployment';
import ContactPersonDependent from '__core/shared/model/contact/ContactPersonDependent';
import { ContactMaritalStatusOption } from '__core/shared/model/contact/ContactMaritalStatusOption.enum';
import { ContactCompanyType } from '__core/shared/model/contact/ContactCompanyType.enum';
import { ContactCompanyTrustStructure } from '__core/shared/model/contact/ContactCompanyTrustStructure.enum';
import { ContactDriverLicenceType } from '__core/shared/model/contact/ContactDriverLicenceType.enum';
import { ContactEmploymentBasis } from '__core/shared/model/contact/ContactEmploymentBasis.enum';
import { ContactEmploymentClass } from '__core/shared/model/contact/ContactEmploymentClass.enum';
import { ContactEmploymentPriority } from '__core/shared/model/contact/ContactEmploymentPriority.enum';
import { ContactEmploymentType } from '__core/shared/model/contact/ContactEmploymentType.enum';
import { ContactGender } from '__core/shared/model/contact/ContactGender.enum';
import { ContactMedicareCardColor } from '__core/shared/model/contact/ContactMedicareCardColor.enum';
import { ContactNextOfKinRelationship } from '__core/shared/model/contact/ContactNextOfKinRelationship.enum';
import { ContactPersonalReferenceRelationship } from '__core/shared/model/contact/ContactPersonalReferenceRelationship.enum';
import { ContactResidentialStatusOption } from '__core/shared/model/contact/ContactResidentialStatusOption.enum';
import { ContactResidencyStatusOption } from '__core/shared/model/contact/ContactResidencyStatusOption.enum';
import { ContactSourceOfWealth } from '__core/shared/model/contact/ContactSourceOfWealth.enum';
import { ContactCreditScoreType } from '__core/shared/model/contact/ContactCreditScoreType.enum';
import ContactCreditScore from '__core/shared/model/contact/ContactCreditScore';
import contactCreditScoreBox from './contactCreditScoreBox.component';
import contactCompanyDetailsBox from './contactCompanyDetailsBox.component';
import simpleContactsList from './simpleContactsList.component';
import stContactViewImportantList from './contactViewImportantList.component';
import contactViewController from './contactView.controller';
import stContactsWithClientAccessList from './contactsWithClientAccessList.component';
import stContactsSimpleEdit from './contactsSimpleEdit.component';
import stContactSpouse from './contactSpouse.component';
import stContactsListItem from './contactsListItem.component';
import stContactsList from './contactsList.component';
import stContactsFilter from './contactsFilter.component';
import stContactsDelete from './contactsDelete.component';
import stContactsMailChimp from './contactsMailChimp.component';
import stContactsCampaignMonitor from './contactsCampaignMonitor.component';
import stContactsCampaignMonitorEmbed from './contactsCampaignMonitorEmbed.component';
import contactsController from '__core/client/controller/Contacts';
import stContactLiabilitiesList from './contactLiabilitiesList.component';
import stContactInsurancesList from './contactInsurancesList.component';
import stContactEmployment from './contactEmployment.component';
import contactEditController from './contactEdit.controller';
import stContactCompanyIndividual from './contactCompanyIndividual.component';
import stContactAssetsList from './contactAssetsList.component';
import stContactAssetCommitmentSchedulesList from './contactAssetCommitmentSchedulesList.component';

export default angular
  .module('st.Contact', ['st.Core', 'angular-cache', 'st.Core.GoogleMaps'])
  .factory('Contact', () => Contact)
  .factory('CompanyIndividual', () => ContactCompanyIndividual)
  .factory('Employment', () => ContactPersonEmployment)
  .factory('Dependent', () => ContactPersonDependent)
  .factory('ContactMaritalStatusOption', () => ContactMaritalStatusOption)
  .factory('ContactCompanyType', () => ContactCompanyType)
  .factory('ContactCompanyTrustStructure', () => ContactCompanyTrustStructure)
  .factory('ContactCreditScoreType', () => ContactCreditScoreType)
  .factory('ContactCreditScore', () => ContactCreditScore)
  .factory('ContactDriverLicenceType', () => ContactDriverLicenceType)
  .factory('ContactEmploymentBasis', () => ContactEmploymentBasis)
  .factory('ContactEmploymentClass', () => ContactEmploymentClass)
  .factory('ContactEmploymentPriority', () => ContactEmploymentPriority)
  .factory('ContactEmploymentType', () => ContactEmploymentType)
  .factory('ContactGender', () => ContactGender)
  .factory('ContactMedicareCardColor', () => ContactMedicareCardColor)
  .factory('ContactNextOfKinRelationship', () => ContactNextOfKinRelationship)
  .factory('ContactPersonalReferenceRelationship', () => ContactPersonalReferenceRelationship)
  .factory('ContactResidentialStatusOption', () => ContactResidentialStatusOption)
  .factory('ContactResidencyStatusOption', () => ContactResidencyStatusOption)
  .factory('ContactSourceOfWealth', () => ContactSourceOfWealth)
  .component('contactCreditScoreBox', contactCreditScoreBox)
  .component('contactCompanyDetailsBox', contactCompanyDetailsBox)
  .component('simpleContactsList', simpleContactsList)
  .component('stContactViewImportantList', stContactViewImportantList)
  .controller('contactViewController', contactViewController)
  .component('stContactsWithClientAccessList', stContactsWithClientAccessList)
  .component('stContactsSimpleEdit', stContactsSimpleEdit)
  .component('stContactSpouse', stContactSpouse)
  .component('stContactsListItem', stContactsListItem)
  .component('stContactsList', stContactsList)
  .component('stContactsFilter', stContactsFilter)
  .component('stContactsDelete', stContactsDelete)
  .component('stContactsMailChimp', stContactsMailChimp)
  .component('stContactsCampaignMonitor', stContactsCampaignMonitor)
  .component('stContactsCampaignMonitorEmbed', stContactsCampaignMonitorEmbed)
  .controller('contactsController', contactsController)
  .component('stContactLiabilitiesList', stContactLiabilitiesList)
  .component('stContactInsurancesList', stContactInsurancesList)
  .component('stContactEmployment', stContactEmployment)
  .controller('contactEditController', contactEditController)
  .component('stContactCompanyIndividual', stContactCompanyIndividual)
  .component('stContactAssetsList', stContactAssetsList)
  .component('stContactAssetCommitmentSchedulesList', stContactAssetCommitmentSchedulesList)
  .service('contactService', ($http, dataService, Contact) => ({
    createContact: (doc) => dataService.createDocument(Contact, doc),
    deleteContact: (doc) => dataService.deleteDocument(Contact, doc),
    readContact: (doc) => dataService.readDocument(Contact, doc),
    updateContact: (doc) => dataService.updateDocument(Contact, doc)
  }))
  .service(
    'contactsService',
    ($http, $rootScope, CacheFactory, dataService, Contact, CONTACT) => {
      let cache;
      if (!CacheFactory.get(CONTACT.CACHE.NAME)) {
        cache = CacheFactory(CONTACT.CACHE.NAME, CONTACT.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || CONTACT.CACHE.NAME,
          params
        });
      return {
        clearCache: () => cache.removeAll(),
        getAvailable: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getAvailable'),
            params?.ignoreCache === true,
            Contact.build,
            $http.get,
            CONTACT.API.AVAILABLE,
            { params }
          ),
        getSpecific: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getSpecific'),
            params?.ignoreCache === true,
            Contact.build,
            $http.post,
            CONTACT.API.SPECIFIC,
            { params }
          ),
        getWithClientAccess: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getWithClientAccess'),
            params?.ignoreCache === true,
            Contact.build,
            $http.get,
            CONTACT.API.WITH_CLIENT_ACCESS,
            { params }
          ),
        getTop: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getTop'),
            params?.ignoreCache === true,
            Contact.build,
            $http.get,
            CONTACT.API.TOP,
            { params }
          ),
        deleteContacts: (params) =>
          dataService.apiRequest(null, null, null, null, $http.post, CONTACT.API.DELETE, {
            params
          })
      };
    }
  )
  .constant('CONTACT', {
    API: {
      AVAILABLE: '/api/v1/contacts/available/',
      SPECIFIC: '/api/v1/contacts/specific/',
      TOP: '/api/v1/contacts/top/',
      DELETE: '/api/v1/contacts/delete/',
      UPLOAD: '/api/v1/contact/avatar-upload/',
      WITH_CLIENT_ACCESS: '/api/v1/contacts/with-client-access/',
      EQUIFAX_SUBMIT: '/api/v1/integration/equifax/submit-enquiry'
    },
    LIMITS: {
      MULTIPLE: false,
      ALLOWED_MIME: 'image/*',
      ALLOWED_EXTENSIONS: '.jpeg,.jpg,.png',
      MIN_WIDTH: '256',
      MIN_HEIGHT: '256'
    },
    FIELDS: {
      LIST: {
        list: [
          'id',
          'avatar',
          {
            person: {
              information: ['firstName', 'middleName', 'familyName'],
              contact: ['primaryCode', 'primary', 'email', 'address']
            }
          },
          {
            company: {
              information: ['name'],
              contact: ['phoneCode', 'phone', 'email', 'address']
            }
          },
          'idLabels',
          'isCompany',
          'isMarketing',
          'isActive',
          'timeStamp'
        ]
      },
      WTF_LIST: {
        list: [
          'id',
          'idOwner',
          'avatar',
          {
            person: {
              employments: ['id', 'type', 'employerName', 'isCurrent'],
              information: ['type', 'firstName', 'middleName', 'familyName', 'idSpouse'],
              contact: ['primaryCode', 'primary', 'email', 'address']
            }
          },
          {
            company: {
              information: ['type', 'name'],
              contact: ['phoneCode', 'phone', 'email', 'address']
            }
          },
          'assets',
          'liabilities',
          'labels',
          'idLabels',
          'isClient',
          'isCompany',
          'isMarketing',
          'isUpdatesAndReminders',
          'isActive',
          'timeStamp'
        ]
      }
    },
    FILTERS: {
      OWNER: {
        path: 'idOwner',
        type: { name: 'str' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      LABEL: {
        path: 'idLabels',
        type: { name: 'arr' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      LENDER: {
        path: '()contact.lender',
        type: { name: 'str' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      LOAN_PURPOSE: {
        path: '()contact.liabilities.loan.purpose',
        type: { name: 'str' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      REPAYMENT_TYPE: {
        path: '()contact.liabilities.repayment.type',
        type: { name: 'str' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      RATE_TYPE: {
        path: '()contact.liabilities.rate.type',
        type: { name: 'str' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      PERSON_EMPLOYMENT_TYPE: {
        path: '()contact.person.employments.type.name',
        type: { name: 'str' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      PERSON_GENDER: {
        path: 'person.information.gender.name',
        type: { name: 'str' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      PERSON_DOB: {
        path: 'person.information.dateOfBirth',
        type: { name: 'num' },
        operator: { name: 'btw' },
        operatorNot: false,
        values: []
      },
      ADDRESS_STATE: {
        path: 'person.contact.address.state||company.contact.address.state',
        type: { name: 'str' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      ADDRESS_POSTCODE: {
        path: 'person.contact.address.postCode||company.contact.address.postCode',
        type: { name: 'num' },
        operator: { name: 'btw' },
        operatorNot: false,
        values: []
      },
      ENTITY_TYPE_COMPANY: {
        path: 'isCompany',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      ENTITY_TYPE_PERSON: {
        path: 'isCompany',
        type: { name: 'bool' },
        operator: { name: 'ne' },
        operatorNot: false,
        values: []
      },
      STATUS_ACTIVE: {
        path: 'isActive',
        type: { name: 'bool' },
        operator: { name: 'ne' },
        operatorNot: false,
        values: []
      }
    },
    CACHE: {
      NAME: 'contactsCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
